import { useAllocationDraft } from "../hooks/useAllocationDraft";
import type { RemittanceAllocationConfig } from "@capture/shared";
import type { StationTransaction } from "../api/client";
import { formatMoneyCents as money } from "../lib/money";
import styles from "./RemittanceStation.module.css";

export function AllocationTable({
  transaction, config, paymentTotalCents, canEdit,
}: {
  transaction: StationTransaction;
  config: RemittanceAllocationConfig;
  paymentTotalCents: number;
  canEdit: boolean;
}) {
  const { rows, remainder, setRow, autofill, save } = useAllocationDraft(transaction, config, paymentTotalCents);
  const byTarget = new Map(rows.map((r) => [r.targetId, r.amountCents]));

  return (
    <div className={styles.allocation}>
      <div className={styles.allocationHead}>
        <span>Allocation</span>
        {canEdit && <button type="button" onClick={autofill}>Autofill</button>}
      </div>
      <table className={styles.allocationTable}>
        <tbody>
          {config.targets.map((t) => (
            <tr key={t.id}>
              <th scope="row">{t.label}</th>
              <td>
                <input
                  type="number" step="0.01" inputMode="decimal" aria-label={t.label}
                  disabled={!canEdit}
                  value={((byTarget.get(t.id) ?? 0) / 100)}
                  onChange={(e) => setRow(t.id, Math.round(parseFloat(e.target.value || "0") * 100))}
                  onBlur={() => canEdit && void save()}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className={styles.allocationRemainder} data-zero={remainder === 0}>
        Remainder {money(remainder)}
      </div>
    </div>
  );
}
